import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MenuOption, ProductMaterial } from 'app/profile/models/site.model';
import { SiteService } from 'app/profile/services/site.service';
import { TslOption } from '@tesla/ng-tds';
import { I18nService } from 'app/shared/services/i18n.service';

@Component({
    selector: 'app-material-form-dialog',
    templateUrl: './material-form-dialog.component.html',
    styleUrls: ['./material-form-dialog.component.scss']
})
export class MaterialFormDialogComponent implements OnInit {
    materialClasses$: Observable<MenuOption[]>;
    materialGrades$: Observable<MenuOption[]>;

    // editor form
    editorForm: FormGroup;

    constructor(private fb: FormBuilder,
        private service: SiteService,
        public dialogRef: MatDialogRef<MaterialFormDialogComponent>,
        private translate: I18nService,
        @Inject(MAT_DIALOG_DATA) public data: { isTool: boolean, model: ProductMaterial }) {
            this.editorForm = this.fb.group({
                class: ['', Validators.required],
                grade: ['', Validators.required],
            });
        }

    ngOnInit() {
        this.loadResources();
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onSave(): void {
        if (this.editorForm.invalid) {
            return;
        }

        this.data.model.classId = this.editorForm.get("class").value.id;
        this.data.model.className = this.editorForm.get("class").value.description;
        this.data.model.gradeId = this.editorForm.get("grade").value.id;
        this.data.model.gradeName = this.editorForm.get("grade").value.description;
        this.dialogRef.close(this.data);
    }

    onClassSelected(option: TslOption): void {
        const selected: MenuOption = option.value;
        this.materialGrades$ = this.service.getMaterialGrades(selected.id);
    }

    private loadResources(): void {
        this.materialClasses$ = this.service.getMaterialClases();
    }
}
